/* RV·C Header behaviour — preview theme only */
(function () {
  var hd = document.querySelector('[data-rvc-hd]');
  if (!hd) return;
  var section = hd.closest('.shopify-section') || hd.parentNode;
  var doc = document.documentElement;
  var desktop = window.matchMedia('(min-width: 990px)');

  function setHeaderHeight() {
    doc.style.setProperty('--header-height', hd.offsetHeight + 'px');
    doc.style.setProperty('--rvc-header-height', hd.offsetHeight + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);

  /* ---------- mega menu ---------- */
  var items = Array.prototype.slice.call(hd.querySelectorAll('[data-rvc-mega]'));
  var openTimer, closeTimer;
  function openItem(item) {
    clearTimeout(closeTimer);
    items.forEach(function (i) { if (i !== item) closeItem(i, true); });
    item.classList.add('is-open');
    var t = item.querySelector('[data-rvc-mega-trigger]');
    if (t) t.setAttribute('aria-expanded', 'true');
  }
  function closeItem(item, now) {
    clearTimeout(openTimer);
    var doClose = function () {
      item.classList.remove('is-open');
      var t = item.querySelector('[data-rvc-mega-trigger]');
      if (t) t.setAttribute('aria-expanded', 'false');
    };
    if (now) doClose(); else closeTimer = setTimeout(doClose, 160);
  }
  function closeAll() { items.forEach(function (i) { closeItem(i, true); }); }

  items.forEach(function (item) {
    var trigger = item.querySelector('[data-rvc-mega-trigger]');
    var panel = item.querySelector('[data-rvc-mega-panel]');
    item.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch' || !desktop.matches) return;
      clearTimeout(closeTimer);
      openTimer = setTimeout(function () { openItem(item); }, 70);
    });
    item.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'touch') return;
      clearTimeout(openTimer);
      closeItem(item);
    });
    if (panel) {
      panel.addEventListener('pointerenter', function () { clearTimeout(closeTimer); });
    }
    trigger.addEventListener('click', function (e) {
      // touch / keyboard: first activation opens, second follows the link
      var pointerTouch = e.pointerType === 'touch' || (window.matchMedia('(hover: none)').matches);
      if (!item.classList.contains('is-open') && (pointerTouch || e.detail === 0)) {
        e.preventDefault();
        openItem(item);
      }
    });
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); openItem(item); var f = panel && panel.querySelector('a'); if (f) f.focus(); }
    });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) closeItem(item, true);
    });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); closeDrawer(); } });
  document.addEventListener('click', function (e) { if (!hd.contains(e.target)) closeAll(); });

  /* ---------- search ---------- */
  var search = hd.querySelector('[data-rvc-search]');
  if (search) {
    search.addEventListener('toggle', function () {
      if (search.open) { closeAll(); var inp = search.querySelector('input[type=search]'); if (inp) setTimeout(function () { inp.focus(); }, 30); }
    });
    document.addEventListener('click', function (e) { if (search.open && !search.contains(e.target)) search.open = false; });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && search.open) search.open = false; });
  }

  /* ---------- drawer ---------- */
  var drawer = document.querySelector('[data-rvc-drawer]');
  var openBtn = hd.querySelector('[data-rvc-drawer-open]');
  var lastFocus;
  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    doc.classList.add('rvc-drawer-lock');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    var x = drawer.querySelector('.rvc-drawer__x'); if (x) x.focus();
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    doc.classList.remove('rvc-drawer-lock');
    if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  }
  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (drawer) {
    drawer.querySelectorAll('[data-rvc-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    drawer.querySelectorAll('[data-rvc-acc]').forEach(function (g) {
      var btn = g.querySelector('[data-rvc-acc-btn]'), panel = g.querySelector('[data-rvc-acc-panel]');
      btn.addEventListener('click', function () {
        var open = g.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.hidden = !open;
      });
    });
    desktop.addEventListener('change', function (e) { if (e.matches) closeDrawer(); });
  }

  /* ---------- sticky: hide on scroll down, show on scroll up ---------- */
  var mode = hd.getAttribute('data-sticky');
  if (mode === 'none') {
    section.style.position = 'relative';
  } else if (mode === 'on-scroll-up') {
    var last = window.pageYOffset, ticking = false;
    function onScroll() {
      var y = window.pageYOffset;
      var h = hd.offsetHeight;
      var menuOpen = hd.querySelector('.rvc-hd__item.is-open') || (search && search.open);
      if (!menuOpen && y > last && y > h + 40) section.classList.add('rvc-hd-hidden');
      else if (y < last - 2 || y <= h) section.classList.remove('rvc-hd-hidden');
      last = y; ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  }

  /* Rise's cart-notification looks for sticky-header.reveal(); make sure our bar is visible when it fires */
  document.addEventListener('cart:refresh', function () { section.classList.remove('rvc-hd-hidden'); });
  var cn = document.querySelector('cart-notification');
  if (cn) {
    var mo = new MutationObserver(function () { if (cn.querySelector('.cart-notification.active')) section.classList.remove('rvc-hd-hidden'); });
    mo.observe(cn, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }
})();
